// English data for activities - Complete translations

export const activitiesDataEN = {
  'orange-bay': {
    id: 'orange-bay',
    slug: 'orange-bay',
    title: 'Orange Bay Hurghada',
    metaTitle: 'Orange Bay Hurghada – Paradise Island Red Sea | Book Now',
    metaDescription: 'Discover Orange Bay, a paradise island in the Red Sea. Snorkeling, crystal clear waters, lunch included. Easy booking via WhatsApp.',
    h1: 'Orange Bay – Paradise Island in the Red Sea',
    price: 25,
    priceNote: 'Transport + lunch included',
    duration: '1 day',
    departurePoint: 'Hotel',
    departure: 'Between 7:30am and 8:30am',
    return: 'Around 5:00pm',
    stripeLink: 'https://buy.stripe.com/9B6cN44Ml5mwfgP77vdMI03',
    depositAmount: 5,
    shortDescription: 'Discover Orange Bay Island, swim in crystal clear waters and enjoy an exceptional snorkeling session in the Red Sea.',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767543315/orange-bay-hurghada-island_1_zvq1zw.jpg',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767543314/orange-bay-hurghada-island_4_kgfkqc.jpg',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767543316/orange-bay-hurghada-island_5_lf4q4c.jpg'
    ],
    experience: [
      'Pickup from your hotel between 7:30am and 8:30am',
      'Boat departure around 9:00am',
      'Stop at one of the best snorkeling spots (equipment provided)',
      'All-you-can-eat buffet served on the boat',
      'Transfer by motor boat to Orange Bay Island',
      '1h30 of free time on the island (ice cream, cocktails, shisha available as extras)',
      'Return by boat with water games included (banana, sofa)',
      'Return to hotel expected around 5:00pm'
    ],
    included: [
      'Round-trip hotel transfer (if hotel is in Hurghada)',
      'Lunch and drinks',
      'Snorkeling equipment',
      'Water games (banana, sofa)'
    ],
    notIncluded: [
      'Ice cream, cocktails, shisha (optional extras on the island)',
      'Tips (optional)'
    ],
    practicalInfo: {
      duration: '1 day',
      departurePoint: 'Hotel',
      departureTime: 'Between 7:30am and 8:30am',
      returnTime: 'Around 5:00pm'
    },
    faq: [
      {
        question: 'Is the hotel transfer included?',
        answer: 'Yes, pickup from your hotel in Hurghada is included, unless otherwise stated.'
      },
      {
        question: 'How does payment work?',
        answer: 'You book your package with a secure deposit via Stripe. The remaining balance is paid on the day of the excursion, directly to the local provider. No hidden fees — everything is clear from the start.'
      },
      {
        question: 'How does confirmation work?',
        answer: 'After payment, I contact you directly on WhatsApp to confirm all details.'
      },
      {
        question: 'Can I ask questions about this activity?',
        answer: 'Yes, I am available anytime on WhatsApp before and after booking.'
      },
      {
        question: 'Do I need diving experience?',
        answer: 'No. Beginners are welcome and accompanied by professionals.'
      },
      {
        question: 'Is equipment included?',
        answer: 'Yes, all necessary equipment is provided.'
      },
      {
        question: 'Is it suitable for beginners?',
        answer: 'Yes, activities are supervised and adapted for people with no experience.'
      }
    ]
  },
  'dauphins-hurghada': {
    id: 'dauphins-hurghada',
    slug: 'dauphins-hurghada',
    title: 'Swim with Dolphins in Hurghada',
    metaTitle: 'Swim with Dolphins Hurghada – Red Sea Excursion | Book Now',
    metaDescription: 'Swim with wild dolphins in the Red Sea. Supervised excursion, snorkeling included. Easy booking via WhatsApp.',
    h1: 'Swim with Dolphins in Hurghada',
    price: 25,
    priceNote: 'Transport included • Meals and drinks included',
    duration: '1 day',
    departurePoint: 'Hotel',
    departure: 'Around 8:00am',
    return: 'Around 3:30pm',
    stripeLink: 'https://buy.stripe.com/5kQdR83IhcOYc4DbnLdMI04',
    depositAmount: 7,
    shortDescription: 'Organized excursion in the best conditions to maximize chances of approaching dolphins in their natural environment.',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546316/dolphin-house-snorkeling_2_xgicwk.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546317/dolphin-house-snorkeling_1_ydusys.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546314/dolphin-house-snorkeling_4_vngirm.png'
    ],
    experience: [
      'Pickup from your hotel around 8:00am',
      'Transfer to the marina',
      'Boat departure around 9:00am',
      'Safety briefing before entering the water',
      'Supervised swimming with dolphins by 2 experienced instructors',
      'Multiple stops depending on dolphin locations',
      'Snorkeling session possible',
      'All-you-can-eat buffet served on board',
      'Return to marina around 3:00pm',
      'Return transfer to your hotel'
    ],
    included: [
      'Round-trip hotel transfer (Hurghada only)',
      'Meals and drinks',
      'Snorkeling equipment'
    ],
    notIncluded: [
      'Souvenir photos/videos',
      'Tips (optional)'
    ],
    practicalInfo: {
      duration: '1 day',
      departurePoint: 'Hotel',
      departureTime: 'Around 8:00am',
      returnTime: 'Around 3:30pm'
    },
    faq: [
      {
        question: 'Is the hotel transfer included?',
        answer: 'Yes, pickup from your hotel in Hurghada is included, unless otherwise stated.'
      },
      {
        question: 'How does payment work?',
        answer: 'You book your package with a secure deposit via Stripe. The remaining balance is paid on the day of the excursion, directly to the local provider. No hidden fees — everything is clear from the start.'
      },
      {
        question: 'How does confirmation work?',
        answer: 'After payment, I contact you directly on WhatsApp to confirm all details.'
      },
      {
        question: 'Can I ask questions about this activity?',
        answer: 'Yes, I am available anytime on WhatsApp before and after booking.'
      },
      {
        question: 'Are the dolphins in the wild?',
        answer: 'Yes. Dolphins are observed in their natural environment, with respect for their habitat.'
      },
      {
        question: 'Is seeing dolphins guaranteed?',
        answer: 'Sightings are very frequent, but as they are wild animals, they can never be guaranteed 100%.'
      },
      {
        question: 'Is the activity animal-friendly?',
        answer: 'Yes. Trips follow local dolphin protection rules.'
      }
    ]
  },
  'plongee-sous-marine': {
    id: 'plongee-sous-marine',
    slug: 'plongee-sous-marine',
    title: 'Scuba Diving in Hurghada',
    metaTitle: 'Scuba Diving Hurghada – Beginners & Certified | Book Now',
    metaDescription: 'Scuba diving in Hurghada for beginners and certified divers. Exceptional Red Sea sites. Easy booking via WhatsApp.',
    h1: 'Scuba Diving in Hurghada',
    price: 30,
    priceLabel: 'Beginner: €30 • Certified: €40',
    priceNote: 'Transport included • Meals and drinks included',
    duration: '1 day',
    departurePoint: 'Hotel',
    departure: 'Around 8:00am',
    return: 'Around 4:30pm',
    stripeLink: 'https://buy.stripe.com/cNibJ03Ih4isd8HfE1dMI0a',
    depositAmount: 14,
    shortDescription: 'Discover the most beautiful diving sites in the Red Sea during an excursion supervised by professional instructors.',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767552523/scuba-diving-hurghada-underwater.jpg_4_ws4xrr.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767552559/scuba-diving-hurghada-underwater.jpg_2_qofds3.jpg',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767553362/scuba-diving-hurghada-underwater.jpg_3_eu72hs.png'
    ],
    experience: [
      'Hotel pickup around 8:00am',
      'Boat departure around 9:00am',
      'Training during navigation for beginners',
      'Two selected diving sites',
      'Supervised dive (max 10m, ~10 min)',
      'Snorkeling possible depending on conditions',
      'All-you-can-eat buffet on board',
      'Return to marina + hotel transfer'
    ],
    included: [
      'Round-trip hotel transfer',
      'Diving equipment',
      'Snorkeling equipment',
      'Meals and drinks'
    ],
    notIncluded: [
      'Underwater photos/videos',
      'Tips (optional)'
    ],
    practicalInfo: {
      duration: '1 day',
      departurePoint: 'Hotel',
      departureTime: 'Around 8:00am',
      returnTime: 'Around 4:30pm'
    },
    faq: [
      {
        question: 'Is the hotel transfer included?',
        answer: 'Yes, pickup from your hotel in Hurghada is included, unless otherwise stated.'
      },
      {
        question: 'How does payment work?',
        answer: 'You book your package with a secure deposit via Stripe. The remaining balance is paid on the day of the excursion, directly to the local provider. No hidden fees — everything is clear from the start.'
      },
      {
        question: 'How does confirmation work?',
        answer: 'After payment, I contact you directly on WhatsApp to confirm all details.'
      },
      {
        question: 'Can I ask questions about this activity?',
        answer: 'Yes, I am available anytime on WhatsApp before and after booking.'
      },
      {
        question: 'Do I need diving experience?',
        answer: 'No. Beginners are welcome and accompanied by professionals.'
      },
      {
        question: 'Is equipment included?',
        answer: 'Yes, all necessary equipment is provided.'
      },
      {
        question: 'Is it suitable for beginners?',
        answer: 'Yes, activities are supervised and adapted for people with no experience.'
      }
    ]
  },
  'safari-combine-quad-desert': {
    id: 'safari-combine-quad-desert',
    slug: 'safari-combine-quad-desert',
    title: 'Super Safari in Hurghada',
    metaTitle: 'Super Safari Hurghada – Quad, Buggy & Desert | Book Now',
    metaDescription: 'Super Safari in Hurghada: quad, buggy, Jeep, Bedouin village and dinner. Easy booking via WhatsApp.',
    h1: 'Super Safari in Hurghada',
    price: 35,
    priceNote: 'Transport included • Dinner included',
    duration: 'Afternoon',
    departurePoint: 'Hotel',
    departure: 'Afternoon',
    return: 'Around 7:00pm',
    stripeLink: 'https://buy.stripe.com/bJe4gy4Ml16g3y7fE1dMI09',
    depositAmount: 5,
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545999/safari-quad-jeep-desert-hurghada.png_7_yph7tf.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545997/safari-quad-jeep-desert-hurghada.png_vjrcen.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545994/safari-quad-jeep-desert-hurghada.png_9_wnaikb.png'
    ],
    shortDescription: 'Explore Hurghada\'s desert on an excursion combining adventure, local culture and traditional dinner.',
    experience: [
      'Hotel pickup in the afternoon',
      '30 minutes of quad biking',
      '20 minutes of buggy riding',
      '25km Jeep trek',
      'Visit to a Bedouin village',
      'All-you-can-eat buffet + oriental show',
      'End around 7:00pm',
      'Return to hotel'
    ],
    included: [
      'All-you-can-eat buffet + 1 drink',
      'Round-trip hotel transfer'
    ],
    notIncluded: [
      'Additional drinks',
      'Professional photos',
      'Tips (optional)'
    ],
    practicalInfo: {
      duration: 'Afternoon',
      departurePoint: 'Hotel',
      departureTime: 'Afternoon',
      returnTime: 'Around 7:00pm'
    },
    faq: [
      {
        question: 'Is the hotel transfer included?',
        answer: 'Yes, pickup from your hotel in Hurghada is included, unless otherwise stated.'
      },
      {
        question: 'How does payment work?',
        answer: 'You book your package with a secure deposit via Stripe. The remaining balance is paid on the day of the excursion, directly to the local provider. No hidden fees — everything is clear from the start.'
      },
      {
        question: 'How does confirmation work?',
        answer: 'After payment, I contact you directly on WhatsApp to confirm all details.'
      },
      {
        question: 'Can I ask questions about this activity?',
        answer: 'Yes, I am available anytime on WhatsApp before and after booking.'
      },
      {
        question: 'Is the quad dangerous?',
        answer: 'No. Quads are easy to handle and instructions are given before departure. The activity is supervised by professionals.'
      },
      {
        question: 'Do I need a license to drive the quad?',
        answer: 'No, no license is required.'
      },
      {
        question: 'Can children participate?',
        answer: 'Yes, children can participate as passengers, depending on age.'
      }
    ]
  },
  'le-caire-1-jour': {
    id: 'le-caire-1-jour',
    slug: 'le-caire-1-jour',
    title: 'Cairo Day Trip from Hurghada – 1 Day',
    metaTitle: 'Cairo Day Trip from Hurghada – Pyramids | Book Now',
    metaDescription: 'Visit Cairo and the Pyramids in 1 day from Hurghada. English-speaking guide, lunch included. Easy booking via WhatsApp.',
    h1: 'Cairo Day Trip from Hurghada – 1 Day',
    price: 75,
    priceNote: 'Transport included • Meals included',
    duration: '1 day',
    departurePoint: 'Hotel',
    departure: '1:00am – 2:00am',
    return: 'Around 11:00pm',
    stripeLink: 'https://buy.stripe.com/cNicN4gv32ak3y7dvTdMI08',
    depositAmount: 15,
    shortDescription: 'Discover Egypt\'s history on a smooth and well-organized excursion.',
    optional: 'Nile cruise: +€10/person',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546253/cairo-day-tour-pyramids_2_xdug4t.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546260/cairo-day-tour-pyramids_2_fo7o2q.jpg',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546252/cairo-day-tour-pyramids_1_xgikpy.jpg'
    ],
    experience: [
      'Hotel pickup between 1:00am and 2:00am',
      'Air-conditioned minivan (8 people max)',
      'Morning snack',
      'Pyramids & Sphinx',
      'English-speaking guide',
      'Cairo Museum',
      'Buffet lunch',
      'Papyrus & perfume factory',
      'Return to hotel around 11:00pm'
    ],
    included: [
      'Entrance tickets',
      'Snack',
      'Buffet + drink',
      'Round-trip hotel transfer'
    ],
    notIncluded: [
      'Nile cruise (+€10)',
      'Tips (optional)'
    ],
    practicalInfo: {
      duration: '1 day',
      departurePoint: 'Hotel',
      departureTime: '1:00am – 2:00am',
      returnTime: 'Around 11:00pm'
    },
    faq: [
      {
        question: 'Is the hotel transfer included?',
        answer: 'Yes, pickup from your hotel in Hurghada is included, unless otherwise stated.'
      },
      {
        question: 'How does payment work?',
        answer: 'You book your package with a secure deposit via Stripe. The remaining balance is paid on the day of the excursion, directly to the local provider. No hidden fees — everything is clear from the start.'
      },
      {
        question: 'How does confirmation work?',
        answer: 'After payment, I contact you directly on WhatsApp to confirm all details.'
      },
      {
        question: 'Can I ask questions about this activity?',
        answer: 'Yes, I am available anytime on WhatsApp before and after booking.'
      }
    ]
  },
  'luxor-1-jour': {
    id: 'luxor-1-jour',
    slug: 'luxor-1-jour',
    title: 'Luxor Day Trip – Valley of the Kings',
    metaTitle: 'Luxor Day Trip from Hurghada – Valley of the Kings | Book Now',
    metaDescription: 'Visit Luxor, Valley of the Kings and Karnak in 1 day from Hurghada. Easy booking via WhatsApp.',
    h1: 'Luxor Day Trip – Valley of the Kings',
    price: 75,
    priceNote: 'Transport included • Meals included',
    duration: '1 day',
    departurePoint: 'Hotel',
    departure: '4:00am – 5:00am',
    return: 'Around 9:00pm',
    stripeLink: 'https://buy.stripe.com/aFa9ASceNeX6fgP0J7dMI07',
    depositAmount: 13,
    shortDescription: 'Discover Luxor and its iconic monuments on a cultural excursion.',
    availableDays: 'Sunday, Tuesday, Thursday',
    optional: 'Banana Island discovery on the Nile: +€10/person',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545542/luxor-day-tour-valley-of-the-kings_6_c7vqbr.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545546/luxor-day-tour-valley-of-the-kings_1_ul1vtl.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545544/luxor-day-tour-valley-of-the-kings_2_o6wses.png'
    ],
    experience: [
      'Hotel pickup between 4:00am and 5:00am',
      'Air-conditioned minivan (8 people max)',
      'Snack',
      'Karnak Temple',
      'Buffet lunch',
      'Hatshepsut Temple',
      'Valley of the Kings',
      'Colossi of Memnon',
      'Nile mini cruise included',
      'Return to hotel around 9:00pm'
    ],
    included: [
      'Tickets',
      'Nile mini cruise',
      'Meal + drink',
      'Round-trip hotel transfer'
    ],
    notIncluded: [
      'Banana Island (+€10)',
      'Tips (optional)'
    ],
    practicalInfo: {
      duration: '1 day',
      departurePoint: 'Hotel',
      departureTime: '4:00am – 5:00am',
      returnTime: 'Around 9:00pm'
    },
    faq: [
      {
        question: 'Is the hotel transfer included?',
        answer: 'Yes, pickup from your hotel in Hurghada is included, unless otherwise stated.'
      },
      {
        question: 'How does payment work?',
        answer: 'You book your package with a secure deposit via Stripe. The remaining balance is paid on the day of the excursion, directly to the local provider. No hidden fees — everything is clear from the start.'
      },
      {
        question: 'How does confirmation work?',
        answer: 'After payment, I contact you directly on WhatsApp to confirm all details.'
      },
      {
        question: 'Can I ask questions about this activity?',
        answer: 'Yes, I am available anytime on WhatsApp before and after booking.'
      }
    ]
  },
  'balade-cheval-hurghada': {
    id: 'balade-cheval-hurghada',
    slug: 'balade-cheval-hurghada',
    title: 'Horse Riding in Hurghada',
    metaTitle: 'Horse Riding Hurghada – Sea, Desert & Sunset | Book Now',
    metaDescription: 'Horse riding in Hurghada between sea and desert at sunset. Dinner included. Easy booking via WhatsApp.',
    h1: 'Horse Riding in Hurghada',
    price: 30,
    priceNote: 'Transport included • Dinner included',
    duration: 'Evening',
    departurePoint: 'Hotel',
    departure: 'Depending on season',
    return: 'In the evening',
    stripeLink: 'https://buy.stripe.com/6oU5kC92B9CM0lV0J7dMI06',
    depositAmount: 10,
    shortDescription: 'An unforgettable experience awaits you on horseback, between sea, desert and sunset.',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767544712/horse-riding-hurghada_2_irdzet.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767544712/horse-riding-hurghada_3_hls8sq.jpg',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767544721/horse-riding-hurghada_1_whlt0w.png'
    ],
    experience: [
      'Pickup from your hotel in Hurghada',
      'Transfer to activity location',
      'Horse ride towards the sea',
      'Walk along the sea with photo stop',
      'Galloping possible (depending on level)',
      'Return through the desert at sunset',
      'All-you-can-eat buffet with oriental show',
      'Return to your hotel with driver'
    ],
    included: [
      'All-you-can-eat buffet and one drink included',
      'Round-trip hotel transfer (if hotel is in Hurghada)'
    ],
    notIncluded: [
      'Additional drinks',
      'Professional photos',
      'Tips (optional)'
    ],
    practicalInfo: {
      duration: 'Evening',
      departurePoint: 'Hotel',
      departureTime: 'Depending on season (confirmed via WhatsApp)',
      returnTime: 'In the evening'
    },
    faq: [
      {
        question: 'Is the hotel transfer included?',
        answer: 'Yes, pickup from your hotel in Hurghada is included, unless otherwise stated.'
      },
      {
        question: 'How does payment work?',
        answer: 'You book your package with a secure deposit via Stripe. The remaining balance is paid on the day of the excursion, directly to the local provider. No hidden fees — everything is clear from the start.'
      },
      {
        question: 'How does confirmation work?',
        answer: 'After payment, I contact you directly on WhatsApp to confirm all details.'
      },
      {
        question: 'Can I ask questions about this activity?',
        answer: 'Yes, I am available anytime on WhatsApp before and after booking.'
      }
    ]
  },
  'paradise-island': {
    id: 'paradise-island',
    slug: 'paradise-island',
    title: 'Paradise Island in Hurghada',
    metaTitle: 'Paradise Island Hurghada – Red Sea Boat Day | Book Now',
    metaDescription: 'Paradise Island excursion in Hurghada: snorkeling, buffet lunch and relaxation on a paradise island. Easy booking via WhatsApp.',
    h1: 'Paradise Island in Hurghada – Boat Day',
    price: 35,
    priceNote: 'Lunch & drinks included • Snorkeling included • Transport included',
    duration: 'Full day',
    stripeLink: 'https://buy.stripe.com/fZudR80w5cOY4CbfE1dMI05',
    depositAmount: 6,
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767608441/paradise-island-turquoise-water.png_5_rwt43u.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767608437/paradise-island-turquoise-water.png_4_pene2a.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767608432/paradise-island-turquoise-water.png_3_lbc2ab.png'
    ],
    departurePoint: 'Hotel',
    departure: 'Between 7:30am and 8:30am',
    return: 'Around 5:00pm',
    shortDescription: 'Explore crystal clear waters and the tropical climate of Paradise Island on a complete Red Sea excursion.',
    mainImage: 'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto,w_1200/v1767608432/paradise-island-turquoise-water.png_3_lbc2ab.png',
    heroFeatures: [
      'Lunch & drinks included',
      'Snorkeling included',
      'Transport included'
    ],
    experienceIntro: 'Departure from your hotel between 7:30am and 8:30am to board around 9:00am.',
    experience: [
      'Pickup from your hotel between 7:30am and 8:30am',
      'Boarding around 9:00am',
      'Head to one of the best diving spots for a snorkeling session with equipment provided',
      'All-you-can-eat buffet with drinks served on board during navigation to Paradise Island',
      'Motor boat transfer to the island',
      '1h30 free time on the island (extras available: ice cream, cocktails, shisha)',
      'Return by boat to main boat with water games option (banana, sofa)',
      'Return to hotel expected around 5:00pm'
    ],
    included: [
      'Full day boat excursion',
      'Snorkeling session with equipment provided',
      'All-you-can-eat buffet lunch',
      'Drinks included',
      'Water games (banana, sofa)',
      'Round-trip hotel transfer (if hotel is in Hurghada)'
    ],
    notIncluded: [
      'Extras on the island (ice cream, cocktails, shisha)'
    ],
    practicalInfo: {
      duration: 'Full day',
      departurePoint: 'Hotel',
      departureTime: 'Between 7:30am and 8:30am (boarding at 9:00am)',
      returnTime: 'Around 5:00pm'
    },
    faq: [
      {
        question: 'Is the hotel transfer included?',
        answer: 'Yes, pickup from your hotel in Hurghada is included, unless otherwise stated.'
      },
      {
        question: 'How does payment work?',
        answer: 'You book your package with a secure deposit via Stripe. The remaining balance is paid on the day of the excursion, directly to the local provider. No hidden fees — everything is clear from the start.'
      },
      {
        question: 'How does confirmation work?',
        answer: 'After payment, I contact you directly on WhatsApp to confirm all details.'
      },
      {
        question: 'Can I ask questions about this activity?',
        answer: 'Yes, I am available anytime on WhatsApp before and after booking.'
      },
      {
        question: 'Do I need diving experience?',
        answer: 'No. Beginners are welcome and accompanied by professionals.'
      },
      {
        question: 'Is equipment included?',
        answer: 'Yes, all necessary equipment is provided.'
      },
      {
        question: 'Is it suitable for beginners?',
        answer: 'Yes, activities are supervised and adapted for people with no experience.'
      }
    ]
  }
};

export default activitiesDataEN;
